import { SectionWrapper } from 'common/components';

export const FieldSectionWrapper = ({
  title,
  children,
  style = {},
  onClick,
}) => {
  const defaultStyle = {
    marginBottom: 6,
    padding: '12px 18px',
  };

  const defaultContainerStyle = {
    padding: '13px 13px',
  };

  return (
    <SectionWrapper
      style={{ ...defaultStyle, ...style }}
      containerStyle={defaultContainerStyle}
      onClick={onClick}
    >
      <>
        {title && (
          <div className='post-to-product-section-wrapper__title'>{title}</div>
        )}
        {children}
      </>
    </SectionWrapper>
  );
};
